import React from 'react';
import UserRoleFunctional from './components/user-role-functional';
import './user-role.scss';

const UserRole = ({ issetup }) => {
	return <UserRoleFunctional {...{ issetup }} />;
};
export default UserRole;
